/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function e(e,a,n){e&&("number"==typeof a?(e.elevationRangeMin=Math.min(e.elevationRangeMin,a),e.elevationRangeMax=Math.max(e.elevationRangeMax,n)):(e.elevationRangeMin=Math.min(e.elevationRangeMin,a.elevationRangeMin),e.elevationRangeMax=Math.max(e.elevationRangeMax,a.elevationRangeMax)))}export{e as expandElevationRange};
